<template>
	
<!-- <img src="./assets/logo.png"> -->
  
  <HelloWorld msg="欢迎来到vue3+element得世界"/>
<!--  <router-view></router-view> -->
	<!-- <img  src="../assets/logo.png"/> -->
	<router-view></router-view>
<!-- <img src="assets/logo.png"> -->
	<footer style="background-color: #060818;padding-top:3rem!important ;padding-bottom: 3rem!important;">
		<p style="text-align: center;color: #fff;">© 2022 ninesleeves.online - All rights Reserved.</p>
		<a href="https://github.com/label3" style="text-align: center;color: #fff;" target="_blank">
			<img src="https://avatars.githubusercontent.com/u/69561610?v=4" style="width:20px;height:20px;vertical-align: middle;" />
			Github</a>
			<p style="text-align: center;color: #fff;">渗透测试工具|网络安全技术|网络安全知识|网站开发|小程序解决方案</p>
		</footer>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
</style>
